export default function (text: string, length = 30) {
  // If the length of str is less than or equal to length
  // just return str--don't truncate it.
  if (text.length <= length) {
    return text;
  }
  // Return text truncated with '...' concatenated to the end of text.
  return `${text.slice(0, length)}...`;
}
